/**
 * Ein Wink an alle, die Zahlen anzeigen: etwas wurde entschieden.
 *
 * Ohne das bliebe die Zahl in der Seitenleiste stehen, während die Liste
 * daneben schon kürzer ist — und man traut dem Werkzeug nicht mehr.
 */

const hoerer = new Set<() => void>()

export function beiAenderung(rueckruf: () => void): () => void {
  hoerer.add(rueckruf)
  return () => {
    hoerer.delete(rueckruf)
  }
}

export function etwasEntschieden(): void {
  for (const rueckruf of hoerer) rueckruf()
}
